import styled from 'styled-components';

const MainContainer = styled.div<React.CSSProperties>`
  background: linear-gradient(180deg, #0f0f0f 79.63%, #303030 100%);
  height: 100vh;
  left: 0;
  position: fixed;
  top: 0;
  width: 100vw;
`;

export default MainContainer;
